<sub-component-dashboard-coletas
  [public]="true"
  [showPages]="showPages"
></sub-component-dashboard-coletas>
